export default {
  getProcessCheckSheet: (state) => state.processCheckSheet,
};
